"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SEGMENT = exports.CLAIMPILL_TYPE = exports.CLAIMPILL_STYLE = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.log-utils");

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.common");

require("./ClaimPill.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const CLAIMPILL_TYPE = {
  PROMO: 'promo',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error'
};
exports.CLAIMPILL_TYPE = CLAIMPILL_TYPE;
const CLAIMPILL_STYLE = {
  NORMAL: 'normal',
  INVERSE: 'inverse'
};
exports.CLAIMPILL_STYLE = CLAIMPILL_STYLE;
const SEGMENT = {
  GP: 'gp',
  EMP: 'emp'
};
/**
 * Stateless component to draw a claim
 * @param {string} type type style to apply
 * @param {string} style style tu apply (normal/inverse)
 * @param {string} segment type segment of ClaimPill
 * @param {string} className className to append to the component
 * @returns {JSX} Component JSX.
 */

exports.SEGMENT = SEGMENT;

const ClaimPill = props => {
  const myProps = (0, _gerenciatdUtils2.setUpPropsByDevice)(props);
  const {
    label,
    type,
    style,
    className
  } = myProps;
  let segment = '';
  ({
    segment
  } = myProps);

  switch (segment) {
    case 'empresas':
    case 'emp':
      segment = 'emp';
      break;

    case 'particulares':
    default:
      segment = 'gp';
      break;
  }

  const segmentCss = `${segment}`;
  const typeCss = `${segment}_type--${type}`;
  const styleCss = `${segment}_style--${style}`;
  const ownCss = className ? ` ${className}` : '';

  if (!label) {
    (0, _gerenciatdUtils.errorLog)('[PillClaim]: label must be !== null');
    return null;
  }

  const htmlLabel = {
    __html: label
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: `claimpill claimpill_${segmentCss} claimpill_${typeCss} claimpill_${styleCss}`,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      dangerouslySetInnerHTML: htmlLabel
    })
  });
};

ClaimPill.propTypes = {
  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Estilos custom"
   * }
   */
  className: _propTypes.default.string,

  /**
   * {
   *  "info": "Definimos el tipo de pillclaim",
   *  "kind": "both",
   *  "beautifulName": "tipo"
   * }
   */
  type: _propTypes.default.oneOf([CLAIMPILL_TYPE.PROMO, CLAIMPILL_TYPE.ACTIVE, CLAIMPILL_TYPE.INACTIVE, CLAIMPILL_TYPE.SUCCESS, CLAIMPILL_TYPE.WARNING, CLAIMPILL_TYPE.PROMO.ERROR]),

  /**
   * {
   *  "info": "estilo del pillclaims,
   *  "kind": "both",
   *  "beautifulName": "estilo"
   * }
   */
  style: _propTypes.default.oneOf([CLAIMPILL_STYLE.NORMAL, CLAIMPILL_STYLE.INVERSE]),

  /**
   * {
   *  "info": "Texto que aparecerá dentro del componente",
   *  "kind": "both",
   *  "beautifulName": "Texto"
   * }
   */
  label: _propTypes.default.string.isRequired,

  /**
   * {
   *  "info": "Necesita para especificar el segmento",
   *  "kind": "both",
   *  "beautifulName": "Segmento"
   * }
   */
  segment: _propTypes.default.oneOf([SEGMENT.GP, SEGMENT.EMP])
};
ClaimPill.defaultProps = {
  className: '',
  type: CLAIMPILL_TYPE.PROMO,
  style: CLAIMPILL_STYLE.NORMAL,
  segment: SEGMENT.GP
};
var _default = ClaimPill;
exports.default = _default;

//# sourceMappingURL=index.js.map